import React, { useState } from 'react';
import { LockKeyhole, BarChart3, AlertCircle, Loader2, CheckCircle2 } from 'lucide-react';
import { sendFeatureRequestAccessNotification } from 'utils/firebase';
import { useAlert } from 'components/UI_components/Alert';

const PermissionEmptyState = ({
  module,
  description
}) => {
  const { addAlert } = useAlert();
  const [requested, setRequested] = useState(false);
  const [loading, setLoading] = useState(false);

  const site_id = Number(localStorage.getItem('site'))
  const site_data = JSON.parse(localStorage.getItem('siteData'))
  const userData = JSON.parse(localStorage.getItem('user'))

  const handleRequestAccess = async () => {
    if (requested || loading) return;

    setLoading(true);
    try {
      const res = await sendFeatureRequestAccessNotification(
        userData,
        module,
        site_id,
        site_data,
        null
      );

      if (res?.throttled) {
        addAlert("A request was already sent within the last hour. Please wait.", "warning");
        setRequested(true);
      } else if (res?.success) {
        addAlert("Access request sent successfully!", "success");
        setRequested(true);
      }
    } catch (error) {
      addAlert("Failed to send access request. Please try again later.", "error");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex flex-col items-center justify-center p-8 bg-gray-50 rounded-lg border border-gray-200 shadow-sm h-64 w-full max-w-3xl mx-auto my-8">
      <div className="mb-2 bg-gray-100 p-4 rounded-full">
        <LockKeyhole className="text-gray-500 w-8 h-8" />
      </div>

      <h3 className="text-xl font-semibold text-gray-800 mb-2">
        {module} Access Restricted
      </h3>

      <p className="text-gray-600 text-center mb-6 max-w-md">
        {description}

      </p>

      <div className="flex items-center gap-6 text-sm text-gray-500">
        <div className="flex items-center">
          <BarChart3 className="w-4 h-4 mr-2" />
          <span>{module} Module</span>
        </div>
        <div className="flex items-center">
          <AlertCircle className="w-4 h-4 mr-2" />
          <span>Permission Required</span>
        </div>
      </div>

      <button
        onClick={handleRequestAccess}
        disabled={requested || loading}
        className={`mt-6 py-2 px-4 rounded-md transition-all duration-200 flex items-center gap-2 ${requested
          ? "bg-emerald-600 text-white cursor-default"
          : "bg-[#3B0069] hover:bg-purple-800 text-white disabled:bg-gray-400"
          }`}
      >
        {loading ? (
          <Loader2 className="w-4 h-4 animate-spin" />
        ) : requested ? (
          <CheckCircle2 className="w-4 h-4" />
        ) : null}
        {loading ? "Sending..." : requested ? "Access Requested!" : "Request Access"}
      </button>
    </div>
  );
};

export default PermissionEmptyState;